var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncomingMapVehicle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 42,
    viewBox: "0 0 47 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.2598 19.4C38.4056 20.0272 38.8261 21.4646 38.1988 22.6105L32.8988 32.2927C32.2716 33.4386 30.8342 33.859 29.6883 33.2318L20.6977 28.3103C19.9338 27.8922 19.6535 26.9339 20.0716 26.17L26.1288 15.1046C26.547 14.3407 27.5052 14.0604 28.2691 14.4786L37.2598 19.4Z",
    fill: "#FCC214"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1322 22.928C37.5141 23.1371 37.6543 23.6162 37.4452 23.9981L33.6595 30.914C33.4504 31.296 32.9713 31.4361 32.5893 31.227C32.2074 31.018 32.0672 30.5388 32.2763 30.1569L36.062 23.241C36.2711 22.859 36.7502 22.7189 37.1322 22.928Z",
    fill: "#464646"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1735 33.1526C31.3262 33.2362 31.5179 33.1801 31.6015 33.0274L32.0558 32.1974C32.1395 32.0447 32.0834 31.853 31.9306 31.7694L31.1007 31.3151C30.9479 31.2315 30.7563 31.2875 30.6726 31.4403L30.2184 32.2702C30.1347 32.423 30.1908 32.6146 30.3436 32.6983L31.1735 33.1526Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2321 22.0866C37.3848 22.1703 37.5765 22.1142 37.6601 21.9614L38.1144 21.1315C38.198 20.9787 38.142 20.7871 37.9892 20.7035L37.1593 20.2492C37.0065 20.1655 36.8149 20.2216 36.7312 20.3744L36.2769 21.2043C36.1933 21.3571 36.2494 21.5487 36.4022 21.6324L37.2321 22.0866Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2891 20.2779C33.053 20.696 33.3333 21.6543 32.9151 22.4182L29.8865 27.9509C29.4684 28.7148 28.5101 28.9951 27.7462 28.5769L25.6714 27.4412C24.9075 27.023 24.6272 26.0648 25.0454 25.3009L28.074 19.7682C28.4921 19.0043 29.4504 18.724 30.2143 19.1421L32.2891 20.2779Z",
    fill: "#464646"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5056 12.9669C26.2695 13.385 26.5498 14.3433 26.1316 15.1072L20.0745 26.1726C19.6563 26.9365 18.6981 27.2168 17.9342 26.7986L9.63511 22.2558C8.1073 21.4195 7.54673 19.5029 8.38305 17.9751L12.9259 9.67607C13.7622 8.14825 15.6787 7.58768 17.2066 8.424L25.5056 12.9669Z",
    fill: "white",
    stroke: "#9F9F9F",
    strokeWidth: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncomingMapVehicle);
export default __webpack_public_path__ + "static/media/incomingMapVehicle.10cbc6d8743c94f4921d2d556dcafcc2.svg";
export { ForwardRef as ReactComponent };